'use client'

import { Suspense } from 'react'
import { Next13ProgressBar } from 'next13-progressbar'

const ProgressBarProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <Suspense>
        <Next13ProgressBar
          height="1px"
          color="#13A767"
          options={{ showSpinner: false }}
          showOnShallow
        />
      </Suspense>
    </>
  )
}

export default ProgressBarProvider
